// Entry point for the web client (Phase 8, spec #77).
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './auth/AuthContext';
import { AppRouter } from './app/router';
import { useAuth } from './auth/AuthContext';
import './app/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found.');
}

function App() {
  const { state } = useAuth();
  if (state.status === 'unknown') {
    return <div className="empty">Checking session…</div>;
  }
  return <AppRouter />;
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
